// src/hooks/useCallWithReturnRequestCallback.ts
import { useCallback } from "react";
import { useCustomerAction, useIsMobileWeb } from "@/hooks";
import { useConfig, useFeaturesEnabled } from "@/contexts/cdpConfig";
import { IS_SERVER } from "@/constants";
export function useCallWithReturnRequestCallback(onReturn) {
    const { customerActionExposeContactPhoneCall } = useCustomerAction();
    const isPreviewMode = useConfig().previewMode;
    const isMobileWeb = useIsMobileWeb();
    const { triggerRequestCallbackModal } = useFeaturesEnabled();
    console.log("🚀 ~ useCallWithReturnRequestCallback ~ triggerRequestCallbackModal:", triggerRequestCallbackModal);
    return useCallback(async (phoneNumber) => {
        if (IS_SERVER || !phoneNumber || isPreviewMode)
            return;
        await customerActionExposeContactPhoneCall();
        // Immediately initiate the native call
        window.location.href = `tel:${phoneNumber.replace(/\s/g, "")}`;
        // Only on mobile web do we listen for their return
        if (!isMobileWeb || !triggerRequestCallbackModal) {
            return;
        }
        let didHide = false;
        const handleVisibility = () => {
            if (document.visibilityState === "hidden") {
                didHide = true;
            }
            if (document.visibilityState === "visible") {
                cleanup();
                onReturn();
            }
        };
        const cleanup = () => {
            document.removeEventListener("visibilitychange", handleVisibility);
            clearTimeout(fallbackTimer);
        };
        document.addEventListener("visibilitychange", handleVisibility);
        // Fallback in case we never see a hidden event, which is
        // iOS Simulator or weird WebViews
        const fallbackTimer = window.setTimeout(() => {
            if (!didHide) {
                cleanup();
                onReturn();
            }
        }, 500);
    }, [
        isPreviewMode,
        isMobileWeb,
        triggerRequestCallbackModal,
        onReturn,
        customerActionExposeContactPhoneCall,
    ]);
}
